export default function initAccordion() {
    let accordions = document.querySelectorAll('.accordion');

    accordions.forEach((accordion) => {
        let entries = accordion.querySelectorAll('.entry');
        let activeIndex = 0;

        open(activeIndex);

        function open(index) {
            closeAll();
            entries[index].classList.add("active");
            activeIndex = index;
        }

        function close(index) {
            entries[index].classList.remove("active");
            activeIndex = null;
        }

        function closeAll() {
            entries.forEach(entry => {
                entry.classList.remove("active");
                activeIndex = null;
            });
        }

        entries.forEach((entry, index) => {
            let title = entry.querySelector('.title');
            title.addEventListener("click", toggle);

            function toggle() {
                if(index === activeIndex) {
                    close(activeIndex);
                } else {
                    open(index);
                }
            }
        });
    });
}